import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { UserPermission } from '../auth/enums/user-permission.enum';
import { MdrDashboardsBrowserComponent } from './components/mdr-dashboards-browser/mdr-dashboards-browser.component';
import { RoleGuard } from '../auth/guards/role.guard';
import { MdrDashboardsOverviewComponent } from './components/mdr-dashboards-overview/mdr-dashboards-overview.component';
import { MdrDashboardsOrgSummaryComponent } from './components/mdr-dashboards-org-summary/mdr-dashboards-org-summary.component';
import { MdrDashboardsConfigurationComponent } from './components/mdr-dashboards-configuration/mdr-dashboards-configuration.component';
import { MdrDashboardsMdrServiceComponent } from './components/mdr-dashboards-mdr-service/mdr-dashboards-mdr-service.component';
import { MdrDashboardsAgentActionsComponent } from './components/mdr-dashboards-agent-actions/mdr-dashboards-agent-actions.component';
import { LcoGuard } from '../auth/guards/lco.guard';
import { LcoOnlyGuard } from '../auth/guards/lco-only.guard';
import { LcoOnlyChildrenGuard } from '../auth/guards/lco-only-children.guard';

const routes: Routes = [
    {
        path: 'browse',
        component: MdrDashboardsBrowserComponent,
        canActivate: [RoleGuard],
        data: {
            title: 'MDR Dashboards',
            roles: [UserPermission.DashboardsRead],
        },
        children: [
            {
                path: 'summary',
                component: MdrDashboardsOrgSummaryComponent,
                canActivate: [LcoOnlyChildrenGuard],
                data: {
                    title: 'MDR Org. Summary Dashboard',
                    subSection: 'dashboards',
                    subSubSection: 'summary',
                    reuse: true,
                },
            },
            {
                path: 'overview',
                component: MdrDashboardsOverviewComponent,
                data: {
                    title: 'MDR Overview Dashboard',
                    subSection: 'dashboards',
                    subSubSection: 'overview',
                    reuse: true,
                },
            },
            {
                path: 'service',
                component: MdrDashboardsOverviewComponent,
                canActivate: [LcoOnlyGuard],
                data: {
                    title: 'MDR Service Dashboard',
                    subSection: 'dashboards',
                    subSubSection: 'service',
                    reuse: true,
                },
            },
            {
                path: 'mdr-service',
                component: MdrDashboardsMdrServiceComponent,
                canActivate: [LcoGuard],
                data: {
                    title: 'MDR Service Dashboard',
                    subSection: 'dashboards',
                    subSubSection: 'mdr-service',
                    reuse: true,
                },
            },
            {
                path: 'agent-actions',
                component: MdrDashboardsAgentActionsComponent,
                canActivate: [LcoGuard],
                data: {
                    title: 'MDR Agent Actions Dashboard',
                    subSection: 'dashboards',
                    subSubSection: 'agent-actions',
                    reuse: true,
                },
            },
            {
                path: 'configuration',
                component: MdrDashboardsConfigurationComponent,
                data: {
                    title: 'MDR Configuration Dashboard',
                    subSection: 'dashboards',
                    subSubSection: 'configuration',
                    reuse: true,
                },
            },
            {
                path: '',
                pathMatch: 'full',
                redirectTo: '',
            },
        ],
    },
    {
        path: '',
        pathMatch: 'full',
        redirectTo: 'browse',
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class MdrDashboardsRoutingModule {}
